var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_70432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2007 25.6507C20.0932 25.6507 25.6807 20.0632 25.6807 13.1707C25.6807 6.27816 20.0932 0.690674 13.2007 0.690674C6.30819 0.690674 0.720703 6.27816 0.720703 13.1707C0.720703 20.0632 6.30819 25.6507 13.2007 25.6507Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6811 13.1706C25.6811 7.80459 22.2944 3.23013 17.542 1.4668V24.8744C22.2944 23.111 25.6811 18.5365 25.6811 13.1706Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.720703 13.1706C0.720703 18.5365 4.10751 23.111 8.85986 24.8743V1.4668C4.10751 3.23013 0.720703 7.80459 0.720703 13.1706Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_70432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.96,
    height: 24.96,
    fill: "white",
    transform: "translate(0.720703 0.690674)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.022e57659d316e4de8a7579b77b04dab.svg";
export { ForwardRef as ReactComponent };